/***
 * Created on 2024/10/30
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useState} from 'react';
import sharedI18n from "common/SharedI18n";
import {I18nextProvider, useTranslation} from "react-i18next";
import {QueryClient, QueryClientProvider, useMutation} from "@tanstack/react-query";
import TextInput from "../common/form/text_input";
import {useOnChange} from "common/Hook";
import {apiPost} from "../../service/api";
import {getErrorMessage, URLHandler} from 'common/ServiceCommon';
import sys_info_svg from '../../static/img/utils/ic-sys-info.svg';
import {Tooltip} from "react-tooltip";


const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false, // default: true
        },
    },
});

function SamlSso(props) {
    const { t } = useTranslation();
    const urlHandler = new URLHandler(location.href);
    const [errorCode, setErrorCode] = useState(urlHandler.url.searchParams.get('errorCode'));
    const {values, setValues, onChange} = useOnChange({
        org_key: urlHandler.getSAMLSSOId() || "",
        keep_me_signed_in: false
    });
    urlHandler.url.searchParams.delete("saml_sso_id");
    urlHandler.url.searchParams.delete("errorCode");
    window.history.pushState({}, '', urlHandler.url);

    const ssoMutate = useMutation({
        mutationFn: async (data) => await apiPost(`/ajax/saml/sso/${values.org_key}${location?.search || ''}`, data),
        onSuccess: (data) => {
            location.href = data.url;
        },
        onError: (error, variables, context) => {
            console.log(error);
            setErrorCode(error?.code || error?.cause?.code || "")
        }
    });

    const onSSOSubmit = async (e) => {
        setErrorCode(null);
        await ssoMutate.mutateAsync({keep_me_signed_in: values.keep_me_signed_in});
    }

    return (
        <section className="common-page-wrapper common-page-wrapper--sign-in">
            <div className="common-page-header">
                <p>{t('@Enter Organization@')}</p>
                <p className="continue-to">{t('@Enter your Organization Identifier to continue@')}</p>
            </div>
            <div className="common-page-body">
                <div className="sign-in--regular">
                    <div className="common-form-group">
                        <div className="comp-input">
                            <div className="input-field--modern">
                                {/*<!-- 輸入錯誤時，輸入框套用 class: input--invalid -->*/}
                                <TextInput
                                    className={errorCode === 1060003 ? 'input--invalid' : ''}
                                    required={true}
                                    name="org_key"
                                    value={values.org_key}
                                    onChange={onChange}
                                    label={t('@Organization Identifier@')}
                                    placeholder={t('@Organization Identifier@')}></TextInput>
                            </div>
                        </div>
                        <p className={`text-error mt-10 ${errorCode ? '' : 'hide'}`}>{t('@The organization you entered is invalid@')} ({errorCode})</p>
                    </div>

                    <div className="common-form-group common-form-group--checkbox-group">
                        <div className="comp-checkbox">
                            <label className="q-checkbox">
                                <input type="checkbox" name="keep_me_signed_in" value="" checked={values.keep_me_signed_in} onChange={(e) => setValues(prev => {
                                    return {...prev, keep_me_signed_in: !prev.keep_me_signed_in}
                                })}/>
                                <div className="display-inline-flex align-items-center">
                                    <span className="display-inline-block mr-8">{t('@Keep me signed in@')}</span>
                                    <img src={sys_info_svg} className="w-18px h-18px"
                                         data-tooltip-id="keep-me-signin"
                                         data-tooltip-content={t('@Extends session duration to 2 days. Not recommended for shared devices.@')}
                                         alt=""/>
                                    <Tooltip id="keep-me-signin"/>
                                </div>
                            </label>
                        </div>
                    </div>

                    <button className="q-btn q-btn--primary btn-medium btn-rounded-normal"
                            data-btn-signin="regular"
                            disabled={!values?.org_key}
                            onClick={onSSOSubmit}>{t('@Continue@')}</button>
                </div>
            </div>
        </section>
    );
}

const SAMLIndex = () => {
    return (
        <I18nextProvider i18n={sharedI18n}>
            <QueryClientProvider client={queryClient}>
                <SamlSso/>
            </QueryClientProvider>
        </I18nextProvider>
    )
}

export default SAMLIndex;